export const FETCH_REVIEWS_REQUEST = 'reviews/FETCH_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'reviews/FETCH_SUCCESS';
export const FETCH_REVIEWS_FAILURE = 'reviews/FETCH_FAILURE';
export const SUBMIT_REVIEW_DONE = 'reviews/SUBMIT_DONE';
